import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2d3b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "difficulty-slider" }

import BaseSlider from '@/components/BaseSlider.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


// These labels and colors are specific to service difficulty slider
export enum SERVICE_DIFFICULTY {
  NEUTRAL = 0,
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}

export const SERVICE_DIFFICULTY_MIN_VALUE = 0
export const SERVICE_DIFFICULTY_MAX_VALUE = 3

export enum SLIDER_COLORS {
  INACTIVE = '#B8B9BB', // $placeholder
  ACTIVE = '#009E21', // $primary-dark
  LINE = '#DADADA',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceDifficultySlider',
  props: {
  modelValue: {
    type: Number,
    default: SERVICE_DIFFICULTY_MIN_VALUE,
  },
},
  emits: ['change'],
  setup(__props, { emit: emits }) {

const props = __props

const i18n = useI18n()




const color = computed(() =>
  props.modelValue ? SLIDER_COLORS.ACTIVE : SLIDER_COLORS.INACTIVE,
)

const difficulty = computed(() => {
  return getTranslation(props.modelValue) || '-'
})

const getTranslation = (key: SERVICE_DIFFICULTY) => {
  return {
    [SERVICE_DIFFICULTY.NEUTRAL]: i18n.t(
      'servicePreferences.difficultyLabels.neutral',
    ),
    [SERVICE_DIFFICULTY.EASY]: i18n.t(
      'servicePreferences.difficultyLabels.easy',
    ),
    [SERVICE_DIFFICULTY.MEDIUM]: i18n.t(
      'servicePreferences.difficultyLabels.medium',
    ),
    [SERVICE_DIFFICULTY.HARD]: i18n.t(
      'servicePreferences.difficultyLabels.hard',
    ),
  }[key]
}

const onDifficultyChange = (value: number) => {
  let finalValue: number = value
  // Round it to integer
  finalValue = Math.round(value)
  // Make sure it stays in >= min value
  finalValue = Math.max(finalValue, SERVICE_DIFFICULTY_MIN_VALUE)
  // Make sure it stays in <= max value
  finalValue = Math.min(finalValue, SERVICE_DIFFICULTY_MAX_VALUE)
  emits('change', finalValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseSlider, {
      color: _unref(color),
      "track-color": SLIDER_COLORS.LINE,
      min: SERVICE_DIFFICULTY_MIN_VALUE,
      max: SERVICE_DIFFICULTY_MAX_VALUE,
      "model-value": __props.modelValue,
      onChange: onDifficultyChange
    }, {
      "label-content": _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(difficulty)), 1)
      ]),
      _: 1
    }, 8, ["color", "track-color", "model-value"])
  ]))
}
}

})